import type { ITranslations } from '@inter-ikea-kompis/types';

/**
 * Placeholder to be able to add translations similar to how they will work when they are added to https://github.com/inter-ikea/ipex-skytta-translations
 * You can keep keys here during development but remember to push them to the translations repo before merging.
 */
export interface ITranslationsToAdd {
  toAdd: Record<string, string>;
}

export const translationsToAdd: ITranslationsToAdd = {
  toAdd: {}
};

export default interface ISkyttaTranslations extends ITranslations {
  skytta: {
    actionAddChr: string;
    actionAddStopbars: string;
    actionChangeChr: string;
    actionChangeDoorLayout: string;
    actionChangeFrames: string;
    actionChangePanels: string;
    actionChangeStopbars: string;
    added: string;
    addedStorageDesign: string;
    backToIntro: string;
    bookAMeeting: string;
    bookAMeetingBody: string;
    bookAMeetingButtonLabel: string;
    bookAMeetingLinkText: string;
    bookAMeetingTitle: string;
    buttonBackToPlanner: string;
    buttonBackToTop: string;
    buttonEnterPlanner: string;
    buttonRangeIntroGuide: string;
    buttonStartPlanning: string;
    captionChrAndCoverPanels: string;
    captionFramesAndRails: string;
    captionPanels: string;
    captionStopbars: string;
    cardContinuePlanningBody: string;
    cardContinuePlanningTitle: string;
    cardNewDesignBody: string;
    cardNewDesignTitle: string;
    centimeters: string;
    chrAddCtaNo: string;
    chrAddCtaYes: string;
    chrAlertCta: string;
    chrAlertMessageBody: string;
    chrAlertMessageTitle: string;
    chrCtaQuestion: string;
    chrHeading: string;
    chrInfoMessage: string;
    chrIntro: string;
    chrSection1: string;
    chrSection2: string;
    chrSuccessMessage: string;
    chrTitle: string;
    chrVideoDescription: string;
    colorAluminium: string;
    colorBlack: string;
    colorWhite: string;
    ctaDescWhatsIncluded: string;
    ctaTitleWhatsIncluded: string;
    customizeYourSkytta: string;
    cuttingAddCtaYes: string;
    cuttingAlertCta: string;
    cuttingAlertMessageBody: string;
    cuttingAlertMessageTitle: string;
    cuttingHeading: string;
    cuttingIntro: string;
    cuttingNotPossibleAlertCta: string;
    cuttingNotPossibleAlertMessageBody: string;
    cuttingNotPossibleAlertMessageTitle: string;
    cuttingSection1: string;
    cuttingSection2: string;
    cuttingTitle: string;
    depth: string;
    distancesAddCtaYes: string;
    distancesAlertCta: string;
    distancesAlertMessageBody: string;
    distancesAlertMessageTitle: string;
    distancesHeading: string;
    distancesIntro: string;
    distancesSection1: string;
    distancesTitle: string;
    doorHeightsAlternativesTitle: string;
    doorHeightsHeading: string;
    doorHeightsIntro: string;
    doorHeightsTitle: string;
    doorHeightSuccessMessage: string;
    doorLayout: string;
    doorLayoutHeading: string;
    doorLayoutIntro: string;
    doorLayoutTitle: string;
    errorPageButton: string;
    errorPageDescription: string;
    errorPageImageAlt: string;
    errorPageTitle: string;
    exitPlannerBody: string;
    exitPlannerTitle: string;
    faqChrSection1Image1Alt: string;
    faqChrSection1Paragraph1: string;
    faqChrSection1Paragraph2: string;
    faqChrSection1Paragraph3: string;
    faqChrSection1Title1: string;
    faqChrTitle: string;
    faqCutDoorsSection1Image1Alt: string;
    faqCutDoorsSection1Paragraph1: string;
    faqCutDoorsSection1Paragraph2: string;
    faqCutDoorsSection1Paragraph3: string;
    faqCutDoorsSection1Title1: string;
    faqCutDoorsSection2Paragraph1: string;
    faqCutDoorsSection2Title1: string;
    faqCutDoorsSection3Image1Alt: string;
    faqCutDoorsSection3Paragraph1: string;
    faqCutDoorsSection3Title1: string;
    faqCutDoorsSection4Image1Alt: string;
    faqCutDoorsSection4Paragraph1: string;
    faqCutDoorsSection4Title1: string;
    faqCutDoorsSection5Image1Alt: string;
    faqCutDoorsSection5Paragraph1: string;
    faqCutDoorsSection5Title1: string;
    faqCutDoorsTitle: string;
    faqDescription: string;
    faqDistancePiecesSection1Image1Alt: string;
    faqDistancePiecesSection1Paragraph1: string;
    faqDistancePiecesSection1Paragraph2: string;
    faqDistancePiecesSection1Title1: string;
    faqDistancePiecesTitle: string;
    faqHeading: string;
    faqOpeningsSection1Image1Alt: string;
    faqOpeningsSection1Paragraph1: string;
    faqOpeningsSection1Paragraph2: string;
    faqOpeningsSection1Title1: string;
    faqOpeningsSection2Image1Alt: string;
    faqOpeningsSection2Paragraph1: string;
    faqOpeningsSection2Paragraph2: string;
    faqOpeningsSection2Paragraph3: string;
    faqOpeningsSection2Paragraph4: string;
    faqOpeningsSection2Title1: string;
    faqOpeningsTitle: string;
    faqOverlapSection1Image1Alt: string;
    faqOverlapSection1Paragraph1: string;
    faqOverlapSection1Paragraph2: string;
    faqOverlapSection1Title1: string;
    faqOverlapSection2Image1Alt: string;
    faqOverlapSection2Paragraph1: string;
    faqOverlapSection2Title1: string;
    faqOverlapSection3Image1Alt: string;
    faqOverlapSection3Paragraph1: string;
    faqOverlapSection3Title1: string;
    faqOverlapTitle: string;
    faqPanelsSection1Image1Alt: string;
    faqPanelsSection1Paragraph1: string;
    faqPanelsSection1Paragraph2: string;
    faqPanelsSection1Title1: string;
    faqPanelsSection2Image1Alt: string;
    faqPanelsSection2Paragraph1: string;
    faqPanelsSection2Paragraph2: string;
    faqPanelsSection2Title1: string;
    faqPanelsSection3Image1Alt: string;
    faqPanelsSection3Paragraph1: string;
    faqPanelsSection3Paragraph2: string;
    faqPanelsSection3Title1: string;
    faqPanelsSection4Image1Alt: string;
    faqPanelsSection4Paragraph1: string;
    faqPanelsSection4Paragraph2: string;
    faqPanelsSection4Title1: string;
    faqPanelsTitle: string;
    faqRailsSection1Paragraph1: string;
    faqRailsSection1Paragraph2: string;
    faqRailsSection1Paragraph3: string;
    faqRailsSection1Title1: string;
    faqRailsSection2Image1Alt: string;
    faqRailsSection2ImageSubtitle1: string;
    faqRailsSection2ImageTitle1: string;
    faqRailsSection2Title1: string;
    faqRailsSection3Image1Alt: string;
    faqRailsSection3ImageSubtitle1: string;
    faqRailsSection3ImageTitle1: string;
    faqRailsSection4Image1Alt: string;
    faqRailsSection4ImageSubtitle1: string;
    faqRailsSection4ImageTitle1: string;
    faqRailsSection5Image1Alt: string;
    faqRailsSection5ImageSubtitle1: string;
    faqRailsSection5ImageTitle1: string;
    faqRailsTitle: string;
    faqStopbarsSection1Image1Alt: string;
    faqStopbarsSection1Paragraph1: string;
    faqStopbarsSection1Paragraph2: string;
    faqStopbarsSection1Paragraph3: string;
    faqStopbarsSection1Title1: string;
    faqStopbarsSection2Image1Alt: string;
    faqStopbarsSection2Paragraph1: string;
    faqStopbarsSection2Title1: string;
    faqStopbarsSection3Image1Alt: string;
    faqStopbarsSection3Paragraph1: string;
    faqStopbarsSection3Paragraph2: string;
    faqStopbarsSection3Title1: string;
    faqStopbarsTitle: string;
    faqSurfaceSection1Image1Alt: string;
    faqSurfaceSection1Paragraph1: string;
    faqSurfaceSection1Title1: string;
    faqSurfaceSection2Image1Alt: string;
    faqSurfaceSection2Paragraph1: string;
    faqSurfaceSection2Title1: string;
    faqSurfaceTitle: string;
    framesRailsDescription: string;
    framesRailsHeading: string;
    framesRailsIntro: string;
    framesRailsTitle: string;
    frontViewTitle: string;
    galleryHeader: string;
    guideDoors1Desc: string;
    guideDoors1ImageAlt: string;
    guideDoors1Title: string;
    guideDoors2Desc: string;
    guideDoors3Desc: string;
    guideDoors4Desc: string;
    guideMeasure1Desc: string;
    guideMeasure1ImageAlt: string;
    guideMeasure1Title: string;
    guideMeasure2Desc: string;
    guideMeasure3Desc: string;
    guideRailDepth1Desc: string;
    guideRailDepth1ImageAlt: string;
    guideRailDepth1Title: string;
    guideRailDepth2Desc: string;
    height: string;
    help: string;
    helpDesc: string;
    helpImageAlt: string;
    helpTitle: string;
    highDoorsLabel: string;
    importStorageText: string;
    importStorageTitle: string;
    inches: string;
    introHeader: string;
    keepInMind: string;
    labelChooseDoors: string;
    labelConsiderLargeOverlap: string;
    labelConsiderOverlap: string;
    labelConsiderSmallOpening: string;
    labelConsiderSmallOverlap: string;
    labelDoors: string;
    labelExploreStorageOptions: string;
    labelGoodFit: string;
    labelHeight: string;
    labelMaxOpening: string;
    labelOther: string;
    labelOverlaps: string;
    labelRails: string;
    labelReachIn: string;
    labelRecommended: string;
    labelRecommendedIfStopbarsAdded: string;
    labelRecommendedStopbarsAdded: string;
    labelRoomDivider: string;
    labelRoomIsTooLarge: string;
    labelSelectStyle: string;
    labelStopbarsInfo: string;
    labelUnavailable: string;
    labelWalkIn: string;
    labelWorksWith: string;
    lowDoorsLabel: string;
    maxOpening: string;
    measurementsBody: string;
    measurementsHeader: string;
    measurementTitle: string;
    menu: string;
    miniConfigurationSummaryDisabledTooltip: string;
    minimumRecommendedDepth: string;
    mobileVersionUnderDevelopmentContent: string;
    mobileVersionUnderDevelopmentTitle: string;
    notAdded: string;
    notAvailable: string;
    openGuide: string;
    openMenu: string;
    openStorageDesign: string;
    overlaps: string;
    pagesGuide: string;
    pagesIntro: string;
    pagesPlanner: string;
    pagesSummary: string;
    panelsFlipButton: string;
    panelsFlipDescription: string;
    panelsHeading: string;
    panelsIntro: string;
    panelsTitle: string;
    panelWithIndex: string;
    patternsDescription: string;
    patternsHeading: string;
    patternsTitle: string;
    planner3dScene: string;
    plannerBannerMessageBody: string;
    plannerBannerMessageBodyKiosk: string;
    plannerBannerMessageTitle: string;
    plannerBannerMessageTitleKiosk: string;
    plannerSceneDescription: string;
    previewImageOf: string;
    printoutMainTitle: string;
    productInformation: string;
    productsUnavailableHeading: string;
    railsTitle: string;
    railsTracks: string;
    rangeIntro: string;
    rangeIntroReachInAltText: string;
    rangeIntroRoomDividerAltText: string;
    rangeIntroWalkInAltText: string;
    rangeName: string;
    rangeTagline: string;
    readLess: string;
    readMore: string;
    roomHeight: string;
    roomTypeTitle: string;
    roomWidth: string;
    save: string;
    saveCombination: string;
    sceneActionsDoorsClose: string;
    sceneActionsDoorsOpen: string;
    sceneActionsMeasurementsHide: string;
    sceneActionsMeasurementsShow: string;
    schematics: string;
    schematicsMeasurementDisplay: string;
    setHeight: string;
    setWidth: string;
    showMore: string;
    sidebarMainHeading: string;
    sidebarSubheading: string;
    skyttaDetails: string;
    sliderIsValidNumber: string;
    sliderIsWithinRange: string;
    sliderSelectedValue: string;
    solutionDetails: string;
    solutionIsTooLargeButton: string;
    solutionIsTooLargeText: string;
    solutionIsTooLargeTitle: string;
    solve: string;
    stageSummaryTooltipTitle: string;
    startFromScratch: string;
    stopbarsCtaQuestion: string;
    stopbarsInfoAddCtaNo: string;
    stopbarsInfoAddCtaYes: string;
    stopbarsInfoHeading: string;
    stopbarsInfoIntro: string;
    stopbarsInfoSection1: string;
    stopbarsInfoSection2: string;
    stopbarsInfoTitle: string;
    storageBehindCardAlt: string;
    storageBehindCardBody: string;
    storageBehindCardTitle: string;
    storageBehindDepthLabel: string;
    storageBehindDesignExamplesHeading: string;
    storageBehindExamplesError: string;
    storageBehindExamplesInfo: string;
    storageBehindExamplesTitle: string;
    storageBehindFaqLinkText: string;
    storageBehindFaqLinkTitle: string;
    storageBehindGalleryIntroText: string;
    storageBehindHeading: string;
    storageBehindImportedDesignHeading: string;
    storageBehindImportedDesignImageAltText: string;
    storageBehindImportedDesignIntroText: string;
    storageBehindIntroText: string;
    storageBehindRangeHeading: string;
    storageGalleryIntroText: string;
    styleTitle: string;
    toastMessagePanelSelection: string;
    toggleMeasurements: string;
    topDownViewClosedTitle: string;
    topDownViewOpenTitle: string;
    unavailableProductsBody: string;
    unavailableProductsTitle: string;
    unavailableProductsWarning: string;
    unsupportedDesignText: string;
    unsupportedDesignTitle: string;
    unusedPanelsDescription: string;
    unusedPanelsDescriptionShort: string;
    unusedPanelsTitle: string;
    warningMessagePanelsCanNotBeCut: string;
    warningMessagePanelsCanNotBeCutShort: string;
    warningMessageProductsUnavailable: string;
    width: string;
    moreThanTwoPanelsHasBeenSelected: string;
    mobileRotateDevice: string;
    selectedDoor: string;
    backToTheScene: string;
    carouselBack: string;
    carouselNext: string;
    selectedDoorFromTheLeft: string;
    dualCurrencyDisclaimerBody: string;
    dualCurrencyDisclaimerTitle: string;
  };
}
